import METHODOLOGYGENDER from 'data/mantechcar24/methodology-gender.json';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { Cell, Legend, Pie, PieChart, Tooltip } from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const MethodologyGender: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');
  const { locale } = useRouter();

  return (
    <div>
      <StyledRecharts className="methodology gender">
        <PieChart width={400} height={400}>
          <Legend
            layout="vertical"
            align="right"
            verticalAlign="top"
            iconType="square"
            width={120}
          />
          <Tooltip
            cursor={{ fill: 'transparent' }}
            labelStyle={{ display: 'none' }}
            separator=": "
            formatter={(value: number) => value.toLocaleString(locale)}
            wrapperClassName="tooltip-y"
          />
          <Pie data={METHODOLOGYGENDER} dataKey="value" cx="50%" cy="28%">
            <Cell name={t('mantechcar24.methodology.gender.females')} />
            <Cell name={t('mantechcar24.methodology.gender.males')} />
            <Cell name={t('mantechcar24.methodology.gender.undefined')} />
          </Pie>
        </PieChart>
      </StyledRecharts>
    </div>
  );
};

export default MethodologyGender;
